import React from 'react';
import {Platform, View, ViewProps} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {VisuallyImpairedProps} from '../visuallyImpaired/form/model';
import {Field} from 'redux-form';
import {ReduxVisuallyImpairedRadio} from '../visuallyImpaired/radio';
import {ReduxVisuallyImpairedColor} from '../visuallyImpaired/colorControl';
import {ReduxVisuallyImpairedSwitch} from '../visuallyImpaired/switch';
import {fontSizes, fontTypes, intervals} from '../../constants/visuallyImpairedValues';
import {maxDesktopContentWidth} from '../../theme/helpers';

export default ({style, onLayout, active, ...props}: VisuallyImpairedProps & ViewProps) => {
  const styles = useStyles(() => ({
    container: {
      backgroundColor: '#ffffff', // theme.color.primaryNonGreyBackground,
      borderBottomColor: '#333333', // theme.color.primaryBlackColor,
      borderBottomWidth: 1,
      borderStyle: 'solid',
      alignItems: 'center',
      paddingVertical: 16,
    },
    subContainer: {
      maxWidth: maxDesktopContentWidth,
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 24,
    },
  }));
  if (!active) {
    return <View onLayout={onLayout} />;
  }
  return (
    <View style={[styles.container, style]} onLayout={onLayout} {...props}>
      <View style={styles.subContainer}>
        <View>
          <Field name='fontSize' component={ReduxVisuallyImpairedRadio} label='Размер шрифта' items={fontSizes} />
        </View>
        <View>
          <Field
            name='switchColor'
            component={ReduxVisuallyImpairedColor}
            label={Platform.OS === 'web' ? 'Цвет сайта' : 'Цвет приложения'}
          />
        </View>
        <View>
          <Field name='switchImages' component={ReduxVisuallyImpairedSwitch} label='Изображения' />
        </View>
        <View>
          <Field name='letterSpacing' component={ReduxVisuallyImpairedRadio} label='Интервал' items={intervals} />
        </View>
        <View>
          <Field name='fontStyle' component={ReduxVisuallyImpairedRadio} label='Шрифт' items={fontTypes} />
        </View>
      </View>
    </View>
  );
};
